module.exports = __webpack_public_path__ + "static/media/29.f37f4899.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/29.png
// module id = 1468
// module chunks = 0